// extracted by mini-css-extract-plugin
module.exports = {"panel-wrap":"Panels_panel-wrap__1doPv"};